import { render, staticRenderFns } from "./MapProject.vue?vue&type=template&id=6552a97e&"
import script from "./MapProject.vue?vue&type=script&lang=js&"
export * from "./MapProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports